import {
  Button, CircularProgress, Dialog, DialogActions, DialogContent, makeStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import getCurrentPageURL from '../../helpers/getCurrentPageURL';

const useStyles = makeStyles(() => ({
  root: {
    justifyContent: 'space-between',
  },
}));

const ConfirmModal = ({
  onCancel, onConfirm, message, isModalOpen, okButtonLabel, cancelButtonLabel,
  event, eventDetail, className, disableOkButton,
}) => {
  const { track } = useAnalytics();
  const classes = useStyles();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const { email: loggedInUserEmail } = useSelector((store) => store.user);

  const handleCancel = () => {
    setIsConfirmed(false);
    onCancel();
    track('ConfirmModal.onCancel', {
      modalTitle: event,
      loggedInUserEmail,
      page: getCurrentPageURL(),
      eventDetail: typeof message === 'string' && !eventDetail ? message : eventDetail,
      cancelButtonLabel,
    });
  };

  const handleOk = () => {
    setIsConfirmed(true);
    onConfirm();
    track('ConfirmModal.onConfirm', {
      modalTitle: event,
      loggedInUserEmail,
      page: getCurrentPageURL(),
      eventDetail: typeof message === 'string' && !eventDetail ? message : eventDetail,
      okButtonLabel,
    });
  };

  if (!onCancel && !onConfirm) return <></>;

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={isModalOpen}
      className={className}
    >
      <DialogContent dividers>
        {message}
      </DialogContent>
      <DialogActions className="justify-between" classes={classes}>
        {onCancel ? (
          <Button autoFocus onClick={handleCancel} color="primary" disabled={isConfirmed}>
            {cancelButtonLabel}
          </Button>
        ) : <></>}
        {onConfirm ? (
          <Button onClick={handleOk} color="primary" disabled={isConfirmed || disableOkButton}>
            {isConfirmed
            && <CircularProgress color="secondary" className="mr-4" size={15} />}
            {okButtonLabel}
          </Button>
        ) : <></>}
      </DialogActions>
    </Dialog>
  );
};

ConfirmModal.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  isModalOpen: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  okButtonLabel: PropTypes.string,
  cancelButtonLabel: PropTypes.string,
  eventDetail: PropTypes.string,
  event: PropTypes.string,
  className: PropTypes.string,
  disableOkButton: PropTypes.bool,
};

ConfirmModal.defaultProps = {
  onCancel: undefined,
  onConfirm: undefined,
  isModalOpen: true,
  okButtonLabel: 'Ok',
  cancelButtonLabel: 'Cancel',
  eventDetail: undefined,
  event: undefined,
  className: undefined,
  disableOkButton: false,
};

export default ConfirmModal;
